import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {ViewAnswerResponse} from "features/model/types/test/test-view-answer-id/testViewAnswerIdShema";


interface ITestViewAnswerId {
    serverData?: ViewAnswerResponse;
    isLoading: boolean;
}

const initialServerData: ViewAnswerResponse = {
    success: false,
    data: {
        user: {
            id: 0,
            groupId: 0,
            avatar: "",
            onlineStatus: "",
            fullName: "",
            cuts: 0,
            efficiency: 0,
            beginningLanguageLevel: "",
            currentLanguageLevel: "",
            attendedClasses: "",
            missingClasses: "",
            homeworks: 0,
            homeworksAll: 0,
        },
        model: {
            id: 0,
            title: "",
            selectedGroupIds: [],
            selectedStudentIds: [],
            published: false,
            hidden: false,
            available: "",
            author: {
                id: 0,
                name: "",
            },
            testItems: [],
        },
        result: {
            answers: [],
            drag: [],
        },
        answersCount: {
            answersAll: null,
            answersRight:null,
            questionsAll:null,
        }
    },
};

const testViewAnswerIdSlice = createSlice({
    name: "testViewAnswerId",
    initialState: {
        serverData: initialServerData,
        isLoading: true,
    } as ITestViewAnswerId,
    reducers: {
        setTestViewAnswerId: (state, action: PayloadAction<ViewAnswerResponse>) => {
            state.isLoading = false;
            state.serverData = action.payload;
        },
        setLoading: (state, action: PayloadAction<{ isLoading: boolean }>) => {
            state.isLoading = action.payload.isLoading;
        },
        resetTestViewAnswerId: (state) => {
            state.isLoading = true;
            state.serverData = initialServerData;
        },
    },
});

export const { setTestViewAnswerId, setLoading, resetTestViewAnswerId } = testViewAnswerIdSlice.actions;
export const testViewAnswerIdReducer = testViewAnswerIdSlice.reducer;
